import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import parse from 'html-react-parser'

const allMedia = graphql`
  query {
    allWpMediaItem {
      edges {
        node {
          databaseId
          sourceUrl
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, quality: 90)
            }
          }
        }
      }
    }
  }
`

const ImageBlock = props => {
  const { attrs, innerHTML } = props
  const { allWpMediaItem } = useStaticQuery(allMedia)
  const image = allWpMediaItem.edges.find(
    ({ node }) => node.databaseId === attrs.id,
  )

  const theImage = image?.node?.localFile

  const figure = parse(innerHTML).filter(item => item.type === 'figure')[0]
  const figcaption = figure.props.children.length
    ? figure.props.children.find(item => item.type === 'figcaption').props
        ?.children
    : null

  const imageSize = size => {
    if (size >= 600 && size <= 900) {
      return 'sm'
    }
    if (size > 900 && size <= 1200) {
      return 'base'
    }
    if (size > 1200 && size <= 1400) {
      return 'lg'
    }
    if (size > 1400 && size <= 1600) {
      return 'xl'
    }
    if (size > 1600) {
      return 'xxl'
    }
    return 'sm'
  }

  return (
    <>
      {theImage ? (
        <div
          className={`wp-block block--image image-size-${imageSize(
            theImage.childImageSharp.gatsbyImageData.width,
          )}`}>
          <figure>
            <GatsbyImage alt="" image={getImage(theImage)} />
            {figcaption && <figcaption>{figcaption}</figcaption>}
          </figure>
        </div>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: innerHTML }} />
      )}
    </>
  )
}

export default ImageBlock
